import { Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CenteredContent from './CenteredContent'
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'

const Error500Page = () => {
  const { t } = useTranslation()

  return (
    <CenteredContent sx={{ marginX: 3 }}>
      <ErrorOutlineIcon fontSize="large" sx={{ marginRight: 3 }} />
      <Typography variant="h6">
        {t('errors.error500')}
        <Box sx={{ textAlign: 'center', marginTop: 1 }}>
          <Link to="/">{t('app.homeButton')}</Link>
        </Box>
      </Typography>
    </CenteredContent>
  )
}

export default Error500Page
